export default "__VITE_ASSET__Bj3F2auB__"